import request from '@/utils/airDropRequest'

// 获取空投计划列表
export function getPlans(data) {
  const params = {}
  if (data.page) {
    params.page = data.page
  }
  if (data.pageSize) {
    params.pageSize = data.pageSize
  }
  return request({
    url: '/api/v1.0/tokenlocker/plans',
    method: 'get',
    params
  })
}

// 删除空投计划
export function deletePlan(data) {
  return request({
    url: '/api/v1.0/tokenlocker/deletePlan',
    method: 'post',
    data
  })
}

// 添加空投计划
export function addPlan(data) {
  return request({
    url: '/api/v1.0/tokenlocker/addPlan',
    method: 'post',
    data
  })
}

// 设置空投计划
export function setPlan(data) {
  return request({
    url: '/api/v1.0/tokenlocker/setPlan',
    method: 'post',
    data
  })
}

// 获取空投计划详情
export function getPlanDetail(planID) {
  return request({
    url: `/api/v1.0/tokenlocker/plan/${planID}`,
    method: 'get'
  })
}

// 获取空投记录列表
export function getLockedRecords(data) {
  const params = {}
  const { page = 1, pageSize = 20, planID = undefined } = data
  
  params.page = page
  params.pageSize = pageSize
  if (planID) {
    params.planID = planID
  }
  
  return request({
    url: '/api/v1.0/tokenlocker/lockedRecords',
    method: 'get',
    params
  })
}

// 获取空投统计信息
export function getAirdropStats() {
  return request({
    url: '/api/v1.0/tokenlocker/stats',
    method: 'get'
  })
} 

// 包含csv文件的空投计划
export function includeCsv(data) {
  return request({
    url: '/api/v1.0/tokenlocker/includecsv',
    method: 'post',
    data
  })
}